import ApiService from "@/core/services/api.service";
// action types
export const GET_ROLES = "getRoles";

// mutation types
export const SET_ROLES = "setRoles";

export const SET_ERROR = "setError";
//const url = 'https://apifacturacionbot.contemporaseguros.com/facturacioncomisionapi'
// const url = 'https://localhost:44340'
const state = {
  errors: [],
  roles: []
};

const actions = {
  [GET_ROLES](context) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/facturacioncomisionapi/api/Rol/v1/roles`}, '')
        .then(({ data }) => {
          context.commit(SET_ROLES, data);
          resolve(data);
        })
        .catch(({ response }) => {
          //console.log((response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  }  
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_ROLES](state, data) {
    state.error = {};
    state.roles = data;
  },
};

export default {
  state,
  actions,
  mutations
};
